import { defineStore } from 'pinia';

import { useRootStore } from './root';

import {
  AggregationRepository,
  TransactionAggregationRegisterForm,
} from '@/repositories/generated';
import { OutputPatternKey } from '@/types';
import { TransactionAggregationUiFormSchema } from '@/validations';

type TransactionAggregationStoreState = {
  form?: TransactionAggregationRegisterForm;
};

export const useTransactionAggregationStore = defineStore('transactionAggregation', {
  state: (): TransactionAggregationStoreState => ({
    form: undefined,
  }),
  actions: {
    async aggregate(form: TransactionAggregationUiFormSchema) {
      const rootStore = useRootStore();
      rootStore.isLoading = true;

      this.form = {
        startDateTime: form.startDateTime.toISOString(),
        endDateTime: form.endDateTime.toISOString(),
        criteria: form.criteria,
        filter: {
          companyIds: form.filter.companies.map((value) => value.id),
          shopIds: form.filter.shops.map((value) => value.id),
          terminalIds: form.filter.terminals.map((value) => value.id),
          walletServiceIds: form.filter.walletServices.map((value) => value.id),
        },
        outputPattern: form.outputPattern as OutputPatternKey,
      };

      return AggregationRepository.registerTransactionAggregation({ requestBody: this.form })
        .finally(() => {
          rootStore.isLoading = false;
        });
    },
  },
});
